export enum RolloutEnum {
  AdvancedSchedulerOptions = 'advanced-scheduler-options',
  CCDA = 'ccda',
  ChatInternalLinks = 'chatInternalLinks',
  Cobranding = 'cobranding',
  CustomFormsV2 = 'custom-forms-v2',
  Docusign = 'docusign',
  EHRIntegrators = 'ehr-integrators',
  OutboundNumbers = 'outbound-numbers',
  EmbedBranding = 'embed-branding',
  ExternalId = 'externalId',
  // NOTE is this supposed to be a rollout?
  // https://github.com/lumahealthhq/web-app/pull/4162
  FormBuilder = 'formBuilder',
  Journey = 'journey',
  Labs = 'labs',
  LinkedForms = 'linked-forms',
  LumaBot = 'lumabot',
  LumaBotLiveChat = 'lumabot-livechat',
  LumaBotPoweredByLuma = 'lumabot-poweredbyluma',
  MessagingActivity = 'messaging-activity',
  OldBroadcasts = 'old-broadcasts',
  PatientMerge = 'patient-merge',
  Reports = 'reports',
  SchedulerV2 = 'schedulerV2',
  SettingsV2 = 'settings-v2',
  ThirdPartyIntegration = 'third-party-integration',
  TokensPage = 'tokens-page',
  WaitlistsTags = 'waitlists-tags',
}
